import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {Injectable} from '@angular/core';
import {ApiEndpoint} from './rest/rest.model';
import {RestService} from './rest/rest.service';
import {UuidLicense} from "../models/uuid-license.model";

@Injectable()
export class UuidLicenseService {
  constructor(private rest: RestService) {}
  public getUuids(): UuidLicense[] {
    const list: UuidLicense[] = [];
    this.rest.getCall(ApiEndpoint.UUID_LICENSE).subscribe((t: any) => {
      t.forEach((uuid: UuidLicense) => {
        list.push(uuid);
      });
    });
    return list;
  }
  public saveUuidLicense(tenantLicense: UuidLicense): Observable<UuidLicense> {
    tenantLicense = UuidLicense.format(tenantLicense);
    return this.rest
      .postCall(ApiEndpoint.UUID_LICENSE, tenantLicense)
      .pipe(map((tenant) => new UuidLicense(tenant)));
  }

  public deleteUuid(uuid: UuidLicense): Observable<UuidLicense> {
    return this.rest.deleteCallBody(ApiEndpoint.UUID_LICENSE, null, uuid);
  }

  updateUuidLicense(uuid: UuidLicense) {
    return this.rest.putCall(ApiEndpoint.UUID_LICENSE, uuid);
  }
}
